import { LocalStorageItemDto } from '@suite/local-storage-api';

export class LocalStorageItem {
  readonly key: string;
  readonly value: unknown;
  readonly timestamp: number;

  private constructor(dto: LocalStorageItemDto) {
    this.key = dto.key;
    this.value = this.decodeValue(dto.value);
    this.timestamp = dto.timestamp || Date.now();
  }

  static fromDto(dto: LocalStorageItemDto): LocalStorageItem {
    return new LocalStorageItem(dto);
  }

  static toDto(item: Partial<LocalStorageItem>): Partial<LocalStorageItemDto> {
    const dto: Partial<LocalStorageItemDto> = {};
    
    if (item.key) {
      dto.key = item.key;
    }
    
    if (item.value !== undefined) {
      dto.value = LocalStorageItem.encodeValue(item.value);
    }
    
    if (item.timestamp) {
      dto.timestamp = item.timestamp;
    }
    
    return dto;
  }

  private decodeValue(encodedValue: string): unknown {
    try {
      const decoded = window.atob(encodedValue || '');
      const unescaped = decodeURIComponent(decoded);
      return JSON.parse(unescaped);
    } catch {
      // If decoding fails, return the raw value
      return encodedValue;
    }
  }

  private static encodeValue(value: unknown): string {
    try {
      const str = JSON.stringify(value);
      const escaped = encodeURIComponent(str);
      return window.btoa(escaped);
    } catch {
      // If encoding fails, return string representation
      return String(value);
    }
  }
}